import { emptyStateDecoration } from "~/assets/assets";

export const EmptyState = ({
  primaryText,
  secondaryText,
  classList,
  imageUrl,
}: {
  primaryText: string;
  secondaryText: string;
  classList?: string;
  imageUrl?: string;
}) => {
  return (
    <div
      class={`${classList} my-7 flex flex-col items-center justify-center gap-2 py-16 lg:gap-1`}
    >
      <img
        src={imageUrl ?? emptyStateDecoration}
        alt="No gift cards to show"
        class="h-[140px] w-[140px]"
      />
      <div class="px-12 text-center text-bold lg:px-0">{primaryText}</div>
      <div class="text-medium text-baseSecondaryMedium">{secondaryText}</div>
    </div>
  );
};
